// extracted by mini-css-extract-plugin
export var actionText = "_oj-4";
export var container = "_oj-0";
export var leftSection = "_oj-1";
export var rightSection = "_oj-2";
export var settingsButton = "_oj-6";
export var settingsIcon = "_oj-7";
export var shortcut = "_oj-5";
export var shortcutGroup = "_oj-3";